import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";

const MainTable = () => {
  const actionsButtons = ["export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="accounting/interest-reserve-details"
    skipClick
    columnLabelsDictionary={{
      loanNumber: "Loan #",
    }}
  />;
};

const LmsAccountingIRDetails = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (<MainTable />);
};

export default LmsAccountingIRDetails;